/** The Graph app: a peer product on the rail, plus the local graph tab. */
import { useUi } from "@/store/ui";
import { useGraph } from "@/store/graph";
import { registerCommand } from "./registry";

export function openGraph(): void {
  useUi.getState().setActiveApp("graph");
}

export function openLocalGraph(): void {
  useUi.getState().openRight("graph");
}

registerCommand({
  id: "graph.open",
  title: "Open graph view",
  defaultKeys: "$mod+Shift+g",
  section: "Graph",
  run: openGraph,
});

registerCommand({
  id: "graph.local",
  title: "Open local graph",
  section: "Graph",
  run: openLocalGraph,
});

registerCommand({
  id: "graph.restoreDefaults",
  title: "Graph: restore default settings",
  section: "Graph",
  run: () => useGraph.getState().restoreDefaults("global"),
});
